type SystemType = `both` | `ground_mount` | `roof_mount`

export const getMountTypeLabel = (mount: SystemType | null): string => {
  switch (mount) {
    case `ground_mount`:
      return `Ground`
    case `both`:
      return `Both`
    default:
      return `Roof`
  }
}
